module.exports = __webpack_public_path__ + "static/banner-tablet-c421c2a6c4adf16aef61b46a153c0c5c.png";